import { render } from "./HomepageLayout.vue?vue&type=template&id=16f927fc"
import script from "./HomepageLayout.vue?vue&type=script&lang=js"
export * from "./HomepageLayout.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./HomepageLayout.vue?vue&type=style&index=0&id=16f927fc&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script